import React from 'react';
import {IPropsView} from '../Config/LoadDataBtn.types';
import Button from '../../Button';
import uploadImage from '../../../images/upload_phone.png';

const LoadDataBtnView = ({
    classNameBtn,
    setButtonToBeEnableAfterPress,
    multiple,
    btnTitle,
    onUploadFiles,
    onClickInputFile,
    uploadOnlyOneFile,
    _preventDefault,
    inputOpenFileRef,
    children,
    accept,
    uploadImageSrc}:IPropsView) => (
    <>
        <input
            type='file'
            onKeyUp={_preventDefault }
            onKeyDown={_preventDefault }
            onKeyPress={_preventDefault }
            className={`${classNameBtn} display-none`}
            ref={inputOpenFileRef}
            accept={accept}
            onChange={multiple ? onUploadFiles : uploadOnlyOneFile}
            multiple={multiple}
        />
        {children ? <>{ React.cloneElement(children, { onClick: onClickInputFile }) }</>
            : <>
                {!uploadImageSrc ? <Button
                    classNameButton={classNameBtn}
                    onClick={onClickInputFile}
                    onKeyUp={_preventDefault }
                    setButtonToBeEnableAfterPress={setButtonToBeEnableAfterPress}
                    isDisabledActive={false}
                    onKeyDown={_preventDefault }
                    onKeyPress={_preventDefault }
                >{btnTitle} </Button> : <img alt='upload icon' src={uploadImage} className={classNameBtn} onClick={onClickInputFile} />}
            </>}
    </>
);

export default LoadDataBtnView;
